<div class="card card--clickable" [class.card--active]="active()" (click)="select()">
  <div class="service__header" style="padding: 0px">
    <div class="service__left">
      <status-icon [status]="health()"></status-icon>
      <div class="service__header-caption">
        <div>
          <span class="service__title">{{ gateway().gateway_name }}</span>
        </div>
      </div>
      @if (warn()) {
        <svg-icon
          class="gateway-element__warning"
          src="assets/images/icons/status-malfunction.svg"
          [matTooltip]="warning()"
        ></svg-icon>
      }
    </div>
    @if (active()) {
      <svg-icon class="gateway-element__close" src="assets/images/icons/x.svg" (click)="deselect($event)"></svg-icon>
    }
  </div>
  <service-tags [tags]="tags()" [firewallEnabled]="false"></service-tags>
</div>
